///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GtthInputControlService } from './input-control.service';
import { PasswordStrengthBarComponent } from './password-edit/password-strength-bar.component';
import { GtthSharePipesModule } from '../shared-pipes.module';
import { GtthSharedLibsModule } from '../shared-libs.module';
import { SuiTranslatePipe } from '@siklu/sui-lib';
import { GtthReactiveFormInputComponent } from './reactive-form-input.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        GtthSharePipesModule,
        GtthSharedLibsModule,
        SuiTranslatePipe,
        GtthReactiveFormInputComponent
    ],
    providers: [GtthInputControlService],
    declarations: [PasswordStrengthBarComponent],
    exports: [GtthReactiveFormInputComponent, PasswordStrengthBarComponent]
})
export class GtthReactiveFormsModule {}
